import { render, staticRenderFns } from "./BaseDiagram.vue?vue&type=template&id=2aee61c0&"
import script from "./BaseDiagram.vue?vue&type=script&lang=js&"
export * from "./BaseDiagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports